import React from "react";

import { Icon, IconSize } from "@gaming/xds-react-js";
import { Edit } from "@gaming/xds-react-js-icons";

import * as styles from "./EditIcon.module.css";

export const EditIcon = () => (
  <Icon className={styles.editIcon} icon={Edit} iconSize={IconSize.Custom} />
);
